import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import HamburgerMenu from './HamburgerMenu';
import EmailLink from './EmailLink';
import MobileCTASection from './MobileCTASection';
import AndroidBanner from './AndroidBanner';
import { isWebView } from '../utils/webview';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t, language } = useLanguage();
  const location = useLocation();
  const isWebViewMode = isWebView();
  const showHeader = !isWebViewMode;

  // Handle anchor links after navigation
  useEffect(() => {
    if (location.hash === '#download-section') {
      // Small delay to ensure the page content is fully rendered
      setTimeout(() => {
        const element = document.getElementById('download-section');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          
          // Add animation after scroll completes
          setTimeout(() => {
            element.classList.add('pop-animation');
            
            // Remove animation class after animation completes
            setTimeout(() => {
              element.classList.remove('pop-animation');
            }, 600);
          }, 500); // Wait for scroll to complete
        }
      }, 100);
    }
  }, [location.hash]);

  return (
    <div className="app">
      {showHeader && (
        <header className="main-header">
          <div className="header-content">
            <Link to={`/${language}`}>
              <img src="/logos/horizontal.png" alt="ColQuest Logo" className="logo" />
            </Link>
            <div className="header-right">
              <a 
                href={`/${language}#download-section`}
                className="header-download-btn"
                onClick={(e) => {
                  // If we're already on the landing page, prevent default and scroll smoothly
                  if (window.location.pathname === `/${language}` || window.location.pathname === '/') {
                    e.preventDefault();
                    const element = document.getElementById('download-section');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                      
                      // Add animation after scroll completes
                      setTimeout(() => {
                        element.classList.add('pop-animation');
                        
                        // Remove animation class after animation completes
                        setTimeout(() => {
                          element.classList.remove('pop-animation');
                        }, 600);
                      }, 500); // Wait for scroll to complete
                    }
                  }
                  // If on other pages, let the anchor link work normally
                }}
              >
                {t('landing.cta') || 'Download'}
              </a>
              <HamburgerMenu />
            </div>
          </div>
        </header>
      )}
      <AndroidBanner />
      <main>
        {children}
      </main>
      {!isWebViewMode && (
        <footer>
          <p className="copyright">© {new Date().getFullYear()} ColQuest by Augustin Lafanechere. All rights reserved.</p>
        </footer>
      )}
    </div>
  );
};

export default Layout; 